import type { Dispatch, SetStateAction } from 'react'

export interface RangePickerValue {
	min: number
	max: number
}

export enum FilterType {
	generic = 'generic',
	colorGroups = 'colorGroups',
	sizes = 'sizes',
	price = 'price',
	order = 'order',
}

export enum FilterId {
	subfamilyIds = 'subfamilyIds',
}

export enum FilterAction {
	apply = 'apply',
	close = 'close',
	clear = 'clear',
}
export interface Filter {
	type: FilterType
}

export interface ColorsFilter extends Filter {
	type: FilterType.colorGroups
	colorGroups: { id: string; label: string }[]
}

export interface PriceFilter extends Filter {
	type: FilterType.price
	onSale?: boolean
}

export interface SizesFilter extends Filter {
	type: FilterType.sizes
	sizes: string[]
}

export interface OrderFilter extends Filter {
	type: FilterType.order
}

export interface GenericFilter extends Filter {
	type: FilterType.generic
	id: FilterId.subfamilyIds
	label: string
	choices: { id: string; label: string }[]
	multipleChoice: boolean
}

export interface UserFilter extends Filter {
	label: string
	selection: string[]
	multipleChoice: boolean
	options: { id: string; label: string }[]
	id?: string
}

export interface GenericUserFilter extends UserFilter {
	id: FilterId.subfamilyIds
}

export interface FiltersData {
	filters: Filter[]
	items: Record<string, UseFiltersItem>
	generic: Record<string, Record<string, string[]>>
}

export interface UseFiltersItem {
	productId: string
	colorGroup: string
	sizes: string[]
	price: number
	onSale: boolean
}

export interface UseFiltersSlotItem extends UseFiltersItem {
	id: string
	index: number
	subfamilyIds?: string[]
}

export interface Tag {
	label: string
	type: string
	id?: string
}

export enum PRICE_TYPE {
	MIN = 'min',
	MAX = 'max',
}

export interface FiltersChildProps {
	onApply?: () => void
	onClose?: () => void
	filters: UserFilter[]
	filtersProps: UseFilters
}

export interface HeaderProps {
	hasSelection: boolean
	selectedCount: number
}

export interface ApplyArgs {
	selectedFiltersFromTags?: UserFilter[]
	selectedRangeFromTags?: RangePickerValue
	selectedOrderFromTags?: string
	deletedType?: string
}

export interface TagsData {
	tags: Tag[]
}

export interface UseFilters {
	items: UseFiltersSlotItem[]
	selectedFilters: UserFilter[]
	orderFilter: UserFilter
	selectedOrder: string
	selectedRange: RangePickerValue | undefined
	selectedLimitRange: RangePickerValue | undefined
	selectedCount: number
	appliedFilters: UserFilter[] | undefined
	appliedOrder: string
	appliedRange: RangePickerValue | undefined
	hasSelection: boolean
	disabledValues: string[]
	setSelectedRange: (range: RangePickerValue) => void
	setSelectedOrder: Dispatch<SetStateAction<string>>
	apply: () => void
	clear: () => void
	toggle: (type: string, value: string, id?: string) => void
}

export interface SerializedParams {
	selectedFilters: UserFilter[]
	selectedOrder: string
	selectedRange?: RangePickerValue
	selectedLimitRange?: RangePickerValue
}
